import { render, staticRenderFns } from "./CreateEmployee.vue?vue&type=template&id=951c0b72"
import script from "./CreateEmployee.vue?vue&type=script&lang=js"
export * from "./CreateEmployee.vue?vue&type=script&lang=js"
import style0 from "./CreateEmployee.vue?vue&type=style&index=0&id=951c0b72&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports